<template>
  <div class="teacher-card" @click="onClick">
    <div class="avatar-section">
      <van-image
        class="avatar"
        :src="teacher.avatar"
        width="54px"
        height="54px"
        round
        fit="cover"
        :error-icon="'photo-fail'"
      />
    </div>
    <div class="info-section">
      <div class="name-row">
        <span class="name">{{ teacher.name }}</span>
      </div>
      <div class="subject-row">
        <van-tag type="primary" class="subject">{{ teacher.subject }}</van-tag>
      </div>
      <div class="class-row">
        <span class="class-count">{{ teacher.classCount }}个班</span>
      </div>
    </div>
    <van-icon name="arrow" class="arrow" />
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
const props = defineProps({
  teacher: {
    type: Object,
    required: true,
  },
});
const emits = defineEmits(['click']);
function onClick() {
  emits('click', props.teacher);
}
</script>

<style lang="scss" scoped>
.teacher-card {
  display: flex;
  align-items: flex-start;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 8px 0 rgba(36,102,246,0.03), 0 1.5px 4px 0 rgba(0,0,0,0.02);
  margin: 0 12px 18px 12px;
  padding: 18px 18px 12px 16px;
  position: relative;
  min-height: 72px;
  transition: box-shadow 0.2s;
  cursor: pointer;
  &:active {
    box-shadow: 0 4px 16px 0 rgba(36,102,246,0.08), 0 2px 8px 0 rgba(0,0,0,0.04);
  }
}
.avatar-section {
  width: 54px;
  height: 54px;
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
}
.avatar {
  width: 54px;
  height: 54px;
  border-radius: 10px;
  object-fit: cover;
  background: #f0f0f0;
  border: 1px solid #eaeaea;
}
.info-section {
  flex: 1;
  margin-left: 14px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  height: 54px;
}
.name-row {
  display: flex;
  align-items: flex-start;
  font-size: 17px;
  font-weight: 700;
  color: #222;
  margin-bottom: 4px;
}
.name {
  font-size: 17px;
  font-weight: 700;
  color: #222;
}
.subject-row {
  margin-bottom: 4px;
}
.subject {
  font-size: 12px;
  padding: 1px 10px;
  border-radius: 10px;
  background: #f3f6fd;
  color: #3478f6;
  border: none;
  font-weight: 500;
}
.class-row {
  font-size: 14px;
  color: #888;
}
.class-count {
  font-size: 14px;
  color: #888;
}
.arrow {
  align-self: center;
  color: #c8c9cc;
  font-size: 20px;
  margin-left: 8px;
}
</style> 